import { Helmet } from "react-helmet-async";
import { Grid, Stack } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import { Title } from "@/components/Title";
import { getTrainers } from "@/services/trainer";
import { TrainerCard } from "@/features/trainer/component/TrainerCard";
import { AllBranchSelect } from "@/components/AllBranchSelect";
import { useCurrentUser } from "@/features/authentication/contexts/AuthenticationContext";
import { usePageBottom } from "@/hooks/usePageBottom";
import { BackToTopButton } from "@/components/BackToTopButton";

import type { SelectChangeEvent } from "@mui/material";

const QUERY_KEY = "trainers";

export function TrainerListPage() {
  const {
    homeBranchId,
    fitnessCenter: { branches },
  } = useCurrentUser();
  const [searchParams, setSearchParams] = useSearchParams();
  const reachedBottom = usePageBottom();

  const branchId = useMemo(
    () => searchParams.get("branchId") ?? homeBranchId.toString(),
    [searchParams, homeBranchId],
  );  

  const { data: raw } = useQuery([QUERY_KEY, branchId], () => getTrainers());

  const title = "เทรนเนอร์ทั้งหมดของเรา";
  const data = raw ?? [];
  const isShowBranch = branches.length > 1;

  const onChangeBranch = (event: SelectChangeEvent<number>) => {
    searchParams.set("branchId", event.target.value.toString());
    setSearchParams(searchParams);
  };


  return (
    <Stack
      my={{ xs: 5, sm: 10 }}
      gap={{ xs: 4, sm: 7 }}
      px={{ xs: 3, sm: 6, md: 8 }}
      alignItems="center"
    >
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {reachedBottom && <BackToTopButton />}
      <Title title={title} />
      {isShowBranch && (
        <AllBranchSelect
          value={+branchId}
          onChange={onChangeBranch}
          FormControlProps={{ sx: { width: "100%", maxWidth: 428 } }}
        />
      )}
      <Grid container spacing={{ xs: 2, sm: 4, md: 5 }} alignItems="stretch">
        {data.map((item) => (
          <Grid item xs={6} md={4} lg={3} key={item.id}>
            <TrainerCard data={item} branchId={+branchId} />
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
}
